
import {APIGetUserLocations} from "../api/stores.ts"
import store from '../core/redux/store.jsx'
import {setApiStoreActhual} from '../core/redux/stores/stores.action.jsx'
export async function APIFetchStores(input) {
  if (input == "storesOnly") {
    const responseNew = await APIGetUserLocations();
    store.dispatch(setApiStoreActhual(responseNew.response))
    const response:any = convertApiResponseToFidaStoresOnly(responseNew);
    console.log('store1 response',response);
    
     return response;
  } else {
    const responseNew = await APIGetUserLocations();
    store.dispatch(setApiStoreActhual(responseNew.response))
    const response:any = convertApiResponseToFida(responseNew);
    console.log('store2 response',response);
       return response;
  }
}

function convertApiResponseToFida(apiResponse) {
  const combinedStores = apiResponse.response.myStores
    .filter((t1) => t1.status === 0)
    .concat(
      apiResponse.response.dataAccessStores.filter((t) => t.status === 0)
    );
  // console.log(combinedStores, 'co')
  // Use a Set to store distinct values based on storeNumber
  const distinctStores = Array.from(
    new Set(combinedStores.map((store) => store.storeNumber))
  );

  // Create a new array with distinct stores
  const finalStoreList = distinctStores.map((storeNumber) => {
    return combinedStores.find((store) => store.storeNumber === storeNumber);
  });

  const stores = finalStoreList.map((store) => ({
    id: store._id,
    name: store.title,
    storeCode: store.storeNumber,
    cityId: store.cityId,
    longitude: null,
    latitude: null,
    area: store.area,
    storeTimings: store.storeTimings,
    entrances: store.entrances,
  }));

  let areaManagers;
  if (apiResponse.response.myAreaManagers.length == 0) {
    areaManagers = [];
  } else {
    areaManagers = apiResponse.response.myAreaManagers.map((manager) => ({
      id: manager._id,
      name: manager.title,
      stores: manager.storeCodes
        .map((storeCode) => {
          const store = finalStoreList.find(
            (store) => store.storeNumber === storeCode
          );

          if (store) {
            return {
              id: store._id,
              name: store.title,
              storeCode: store.storeNumber,
              longitude: null,
              latitude: null,
              area: store.area,
              storeTimings: store.storeTimings,
              entrances: store.entrances,
            };
          } else {
            return null;
          }
        })
        .filter((store) => store !== null),
      store: [],
    }));
  }

  let peerGroups;
  if (!apiResponse.response.myPeerGroups.find((x) => x.type == "peerGroup")) {
    peerGroups = [];
  } else {
    peerGroups = apiResponse.response.myPeerGroups
      .filter((peerGroup) => peerGroup.type === "peerGroup")
      .map((peerGroup) => ({
        id: peerGroup._id,
        name: peerGroup.title,
        order: peerGroup.order,
        stores: peerGroup.storeCodes
          .map((storeCode) => {
            const store = finalStoreList.find(
              (store) => store.storeNumber === storeCode
            );
            if (store)
              return {
                id: store._id,
                name: store.title,
                storeCode: store.storeNumber,
                longitude: null,
                latitude: null,
                area: store.area,
                // order: store.order,
                storeTimings: store.storeTimings,
                entrances: store.entrances,
              };
            else return null;
          })
          .filter((store) => store !== null),
        store: [],
      }));
  }

  const regions = getRegions(finalStoreList);
  return {
    data: {
      areaManagers,
      regions,
      stores,
      peerGroups,
      dataAccessStores: apiResponse?.response?.dataAccessStores || [],
      myStores: apiResponse?.response?.myStores || [],
    },
    description: apiResponse.message,
    status: apiResponse.transKey,
  };
}
function convertApiResponseToFidaStoresOnly(apiResponse) {
  let combinedStores;
  if (
    apiResponse &&
    apiResponse.response &&
    apiResponse.response.myStores &&
    apiResponse.response.dataAccessStores
  ) {
    combinedStores = apiResponse.response.myStores
      .filter((t1) => t1.status === 0)
      .concat(
        apiResponse.response.dataAccessStores.filter((t1) => t1.status === 0)
      );
  } else if (apiResponse.response.myStores) {
    combinedStores = apiResponse.response.myStores.filter(
      (t1) => t1.status === 0
    );
  } else if (apiResponse.response.dataAccessStores) {
    combinedStores = apiResponse.response.dataAccessStores.filter(
      (t1) => t1.status === 0
    );
  } else combinedStores = [];
  const stores = combinedStores.map((store) => ({
    id: store._id,
    cityId: store.cityId,
    name: store.title,
    storeCode: store.storeNumber,
    longitude: null,
    latitude: null,
    area: store.area,
    storeTimings: store.storeTimings,
    entrances: store.entrances,
  }));

  return { stores };
}

function getRegions(apiResponse) {
  const result = {};
  apiResponse.forEach((store) => {
    if (store.locationDetails) {
      const { locationDetails } = store;
      const { region, district } = locationDetails;

      if (!result[region]) {
        result[region] = {};
      }
      if (!result[region][district]) {
        result[region][district] = [];
      }

      const mappedStore = {
        id: store._id,
        name: store.title,
        storeCode: store.storeNumber,
        longitude: null,
        latitude: null,
        area: store.area,
        storeTimings: store.storeTimings,
        entrances: store.entrances,
      };

      result[region][district].push(mappedStore);
    }
  });

  const finalResult:any = [];

  for (const region in result) {
    const districts:any =  [];
    for (const district in result[region]) {
      districts.push({
        id: "1", // You can set this id as needed
        name: district,
        stores: result[region][district],
        store: [],
      });
    }
    finalResult.push({
      id: "1", // You can set this id as needed
      name: region,
      districts,
    });
  }

  return finalResult;
}
